module.exports = __webpack_public_path__ + "static/media/iprus-8.ce806eac.png";